const rankings = [
  { rank: 1, title: '某顶流深夜发文内幕全解析', heat: '🔥 328.6万', tag: '24小时爆', change: 'new' },
  { rank: 2, title: '综艺节目录制现场争议事件', heat: '🔥 267.3万', tag: '持续发酵', change: 'up' },
  { rank: 3, title: '某品牌代言人解约风波始末', heat: '215.8万', tag: '多方回应', change: 'up' },
  { rank: 4, title: '新剧路透照曝光主演造型引热议', heat: '176.4万', tag: '话题热', change: 'up' },
  { rank: 5, title: '机场私服引发全网两极化讨论', heat: '142.7万', tag: '争议中', change: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-xs font-label text-primary-600 bg-primary-50 px-3 py-1 rounded-full">实时热度</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-3">
            吃瓜热榜
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-[560px] mx-auto">
            全网吃瓜内容热度排行，实时追踪最受关注的话题
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          {rankings.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl hover:bg-background-100 transition-colors cursor-pointer border-b border-background-200/60 last:border-b-0"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-label font-bold text-sm flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-100 text-primary-600' :
                item.rank === 3 ? 'bg-accent-100 text-accent-700' :
                'bg-background-100 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-label font-medium text-foreground-900 truncate">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-3 flex-shrink-0">
                <span className="text-xs font-label text-accent-600 whitespace-nowrap">{item.heat}</span>
                <span className="hidden sm:inline text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-label whitespace-nowrap">
                  {item.tag}
                </span>
                <span className={`text-xs ${
                  item.change === 'new' ? 'text-primary-600' :
                  item.change === 'up' ? 'text-accent-600' :
                  'text-foreground-400'
                }`}>
                  {item.change === 'new' ? 'NEW' : item.change === 'up' ? '↑' : '↓'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}